'use es6';

export const TEMPLATE_INFO_URL = 'designmanager/v1/templates/by-path';
export const TEMPLATE_URL = 'designmanager/v1/templates';